import { useState } from 'react';
import css from './modal.module.scss';
import Modal from 'src/components/common/modal/modal';
import QuizBlock from './quiz-body';
import QuizInfo from './modal-info';
import classNames from 'classnames';
import { ModalTypes, QuestionAnswers, QuizEntityType, QuizModalProps, QuizResult } from 'src/types/quiz';
import { useGetQuiz } from '../api/queries';
import { toast } from 'react-toastify';
import API from '../api/api';

export default function QuizInfoModal({ quizId, entityId, entityType, onClose }: Readonly<QuizModalProps>) {
  const { data: quiz } = useGetQuiz({ id: quizId });

  const InfoModalTypes = ModalTypes(entityType);

  const [infoType, setInfoType] = useState<JSX.Element | undefined>(InfoModalTypes.Start);
  const [selectedAnswers, setSelectedAnswers] = useState<QuestionAnswers[]>([]);

  const [result, setResult] = useState<QuizResult | undefined>(undefined);

  function handleClose(close: () => void) {
    switch (infoType) {
      case undefined:
        setInfoType(InfoModalTypes.Exit);
        break;
      case InfoModalTypes.Exit:
        setInfoType(undefined);
        break;
      default:
        onClose();
        close();
    }
  }

  function applyInfoActions(close?: () => void) {
    switch (infoType) {
      case InfoModalTypes.Start:
        setInfoType(undefined);
        break;
      case InfoModalTypes.Congrats:
        onClose(result);
        close?.();
        break;
      case InfoModalTypes.TryAgain:
        handleTryAgain(close);
        break;
      default:
        onClose();
        close?.();
    }
  }

  function handleTryAgain(close?: () => void) {
    if (entityType === QuizEntityType.Work) {
      onClose(result);
      close?.();
    } else {
      setInfoType(undefined);
    }
  }

  function submitQuiz(close?: () => void) {
    if (result) {
      close?.();
      return;
    }
    if (!infoType && selectedAnswers.length === quiz.questions.length) {
      API.checkQuiz({ id: quiz.id, answers: selectedAnswers, entityId, entityType }).then(handleResult);
    } else {
      toast.error(`Не надано відповіді на всі питання тестування`);
    }
  }

  function handleResult(result: QuizResult) {
    setInfoType(!result.isComplete ? InfoModalTypes.TryAgain : InfoModalTypes.Congrats);
    setResult(result);
  }

  return (
    <Modal isOpen={true} onClose={onClose} closeOnDocumentClick={false}>
      {(close: () => void) => (
        <div className={css.quizContainer}>
          <div className={css.header}>
            <button onClick={() => handleClose(close)}>×</button>
          </div>
          {infoType ? (
            <QuizInfo
              infoType={infoType}
              InfoModalTypes={InfoModalTypes}
              onApply={() => applyInfoActions(close)}
              onCancel={() => handleClose(close)}
            />
          ) : (
            <div className={classNames(css.quiz, css.started)}>
              <QuizBlock
                questions={quiz?.questions ?? []}
                selectedAnswers={selectedAnswers}
                setSelectedAnswers={setSelectedAnswers}
                applyQuiz={() => submitQuiz(close)}
                correctAnswers={result?.correctAnswers ?? []}
              />
            </div>
          )}
        </div>
      )}
    </Modal>
  );
}
